import { useState, useEffect } from 'react';
import { Box, TextField, Chip, Button } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { useConnect } from '../../../context/connect';
import { ICannedReply } from '../../../interfaces';

import { createCannedResponse, updateCannedResponse } from '../../../api';
import { Loaders } from '../../Loaders';

export const Form = ({
  mode,
  initialData,
  setDataForUpdate,
  setMode,
}: {
  mode: 'create' | 'update';
  initialData?: ICannedReply;
  setDataForUpdate: React.Dispatch<
    React.SetStateAction<ICannedReply | undefined>
  >;
  setMode: React.Dispatch<React.SetStateAction<null | 'create' | 'update'>>;
}) => {
  const { shortcuts, agentInfo, setCannedResponses, setShortcuts } =
    useConnect();
  const [data, setData] = useState<{
    shortcuts: string[];
    canned_reply: string;
  }>({
    shortcuts: [],
    canned_reply: '',
  });
  const [loading, setLoading] = useState<boolean>(false);

  const btnTitle = mode === 'create' ? 'Add response' : 'Update Response';
  const onHandlerClick = async () => {
    if (agentInfo) {
      setLoading(true);
      if (mode === 'create') {
        await createCannedResponse(
          {
            user: agentInfo.user,
            ...data,
          },
          { setCannedResponses, setShortcuts }
        );
      }
      if (mode === 'update' && initialData?.id) {
        await updateCannedResponse(
          {
            id: initialData.id,
            user: agentInfo.user,
            ...data,
          },
          { setCannedResponses, setShortcuts }
        );
        setDataForUpdate(undefined);
      }
      setData({
        shortcuts: [],
        canned_reply: '',
      });
      setMode(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialData) {
      setData({
        shortcuts: initialData.shortcuts,
        canned_reply: initialData.canned_reply,
      });
    }
  }, [initialData]);

  return (
    <Box py={4} px={2}>
      {loading && <Loaders />}
      <Box mb={3}>
        <TextField
          fullWidth
          label="Canned Response"
          placeholder="Canned response text ..."
          InputLabelProps={{
            shrink: true,
          }}
          multiline
          rows={4}
          value={data.canned_reply}
          onChange={(e) =>
            setData((prev) => ({
              ...prev,
              canned_reply: e.target.value,
            }))
          }
          variant="outlined"
        />
      </Box>
      <Box>
        <Autocomplete
          multiple
          id="tags-filled"
          options={shortcuts as string[]}
          freeSolo
          autoSelect
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={<>#{option}</>}
                {...getTagProps({ index })}
              />
            ))
          }
          value={data.shortcuts}
          onChange={(e, value) =>
            setData((prev: any) => ({
              ...prev,
              shortcuts: value.map((i: string) => {
                if (i.includes('#')) {
                  return i.replace('#', '');
                }
                return i;
              }),
            }))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Shortcuts"
              placeholder="#shortcuts"
              InputLabelProps={{
                shrink: true,
              }}
              helperText={
                <>
                  To use a canned response during a chat, type in # and a
                  shortcut. <br />
                  You should press enter to add shortcuts.
                </>
              }
            />
          )}
        />
      </Box>
      <Box display={'flex'} justifyContent={'end'}>
        <Button
          variant="contained"
          color={'primary'}
          size="small"
          onClick={onHandlerClick}
          style={{
            background: 'rgb(37, 124, 175)',
            borderRadius: '2px',
            boxShadow: 'none',
          }}
        >
          {btnTitle}
        </Button>
      </Box>
    </Box>
  );
};
